export default __webpack_public_path__ + "static/media/8R.296eb053.png";